export default {
  dbi_filterSave_filter_setting: `保存筛选器设置`,
  dbi_filterSave_setting_info: `保存的设置可用于情报系统中的所有筛选器`,
  dbi_filterSave_setting_name: `设置名称`,
  dbi_filterSave_input_maximum: `最多支持{max}个字符`,
  dbi_filterSave_save_item: `要保存的条目`,
  dbi_filterSave_replace_setting: `已有同名设置，点击保存可替换该设置。`,
  dbi_filterSave_enter_a_name: `请输入名称`,
  dbi_filterSave_my_filter: `我的筛选器`,
  dbi_filterSave_my_filter_nodata: `没有可用的筛选器`,
  dbi_filterSave_my_filter_search: `搜索筛选器`,
  dbi_filterSave_my_filter_top10: `最多可保存 10 个设置`,
  dbi_filterSave_delete_info: `删除筛选器设置`,
  dbi_filterSave_do_delete: `确认删除？`,
  dbi_filterSave_successful_operation: `操作成功`,
  dbi_filterSave_operation_failure: `操作失败`,
  dbi_filterSave_icon_delect: `删除`,
  dbi_filterSave_duration: `时间段`,
  dbi_filterSave_release: `发布时间`,
  dbi_filterSave_none: `无`,
};
